
import React from 'react'
import Navbar from '../Navbar/Navbar.jsx'
import './Home.css'


const Home = () => {
  return (
    <>
        <Navbar />
        <div className='home-container'>
            <div className="main-title">
                Emmaline Rose       
            </div>
            <div className="career-title">Developer & Designer</div>
        </div>
    </>
  )
}


export default Home





















//*********GLITCH EFFECT**********//

// import React from 'react'
// import './Home.css'

// const Home = () => {
//   return (
//     <div className='home-container'>
//         <div className="c-glitch" style={{background: require('../Images/16F0E768-F96F-45C5-9840-DE2F8AB19FBA.jfif')}}>
//             <div className="c-glitch__img" style={{background: require('../Images/16F0E768-F96F-45C5-9840-DE2F8AB19FBA.jfif')}}></div>
//             <div className="c-glitch__img" style={{background: require('../Images/16F0E768-F96F-45C5-9840-DE2F8AB19FBA.jfif')}}></div>
//             <div className="c-glitch__img" style={{background: require('../Images/16F0E768-F96F-45C5-9840-DE2F8AB19FBA.jfif')}}></div>
//             <div className="c-glitch__img" style={{background: require('../Images/16F0E768-F96F-45C5-9840-DE2F8AB19FBA.jfif')}}></div>
//             <div className="c-glitch__img" style={{background: (require('../Images/16F0E768-F96F-45C5-9840-DE2F8AB19FBA.jfif'))}}></div>
//         </div>
//     </div>
//   )
// }

// export default Home
